import { Avatar } from '@mui/material'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { useContext } from 'react'
import { Link, useParams } from 'react-router-dom'
import GetCourseBatch from '../../../actions/GetCourseBatch'
import { AuthContext } from '../../../context/AuthContext'
import Localbase from 'localbase'
import axios from 'axios'
import ENDPOINT from '../../../data/ENDPOINT'
import SecurityHeaders from '../../../data/SecurityHeaders'
import AnimatePage from '../../../actions/animations/AnimatePage'
const TeamLeaderboard = ({courseUrl,batchId,teamId,limit}) => {

  




const [leader,setLeader] = useState(null)

const getTeamLeader = async ()=>{

    const data = new FormData();

    data.append('course_url', courseUrl);
    data.append('batch_id',batchId);
    data.append('team_id',teamId);
    data.append('limit',limit?limit:5)

  setloading(true)

    const res = await axios.post(ENDPOINT+`team-leaderboard.php`,data,SecurityHeaders)

    if(res){
       setloading(false)
      AnimatePage()
        return setLeader(res.data.data)
    }
}




useEffect(()=>{

getTeamLeader()


},[courseUrl,batchId])

const [loading,setloading] = useState(false)
  return (
    <div className="w-100">
      {leader ? (
        <>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="card-widget-title mb-0" style={{ fontSize: "14.5px", fontWeight: "700", color: "#0f172a" }}>
              🏆 Batch Leaderboard
            </h6>
            <Link className="panel-link" style={{ fontSize: "12px", fontWeight: "600", color: "#f15e22", textDecoration: "none" }} to={"/leaderboard/" + courseUrl + "/" + batchId}>
              View all &rarr;
            </Link>
          </div>

          <div className="d-flex flex-column gap-2 mt-2">
            {leader.map((user, index) => {
              const rank = index + 1;
              let rankStyle = { background: "#f1f5f9", color: "#475569" };
              if (rank === 1) rankStyle = { background: "#fef3c7", color: "#d97706" };
              else if (rank === 2) rankStyle = { background: "#f1f5f9", color: "#475569" };
              else if (rank === 3) rankStyle = { background: "#ffedd5", color: "#b45309" };

              return (
                <div
                  key={index}
                  className={"d-flex w-100 justify-content-between align-items-center p-2 rounded-3 hover-bg-light fade-in-bottom delay" + (index + 1) + "s"}
                  style={{ transition: "background 0.2s ease" }}
                >
                  <Link to={"/u/" + user.user_data.username} className="d-flex align-items-center text-dark col text-decoration-none">
                    <Avatar src={user.user_data.profile_pic} style={{ width: "36px", height: "36px" }} className="me-3" />
                    <div className="overflow-hidden">
                      <h6 className="mb-0 text-truncate text-dark" style={{ fontSize: "13px", fontWeight: "700" }}>
                        {user.user_data.first_name.slice(0, 20) + " " + user.user_data.last_name.slice(0, 20)}
                      </h6>
                      <p className="mb-0 text-secondary text-truncate" style={{ fontSize: "11px" }}>
                        @{user.user_data.username}
                      </p>
                    </div>
                  </Link>
                  <div className="text-end flex-shrink-0 ms-2">
                    <span
                      style={{
                        fontSize: "11px",
                        fontWeight: "750",
                        padding: "3px 8px",
                        borderRadius: "99px",
                        display: "inline-block",
                        ...rankStyle
                      }}
                    >
                      Rank {rank}
                    </span>
                    {/* <p className="mb-0 text-secondary mt-1" style={{ fontSize: "10.5px", fontWeight: "500" }}>
                      {user.marks ? user.marks : 0} pts
                    </p> */}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <>
          {loading ? (
            <div className="text-center py-4 text-muted small">Loading leaderboard...</div>
          ) : (
            <div className="text-center py-4">
              <h6 className="text-dark fw-bold mb-1">No Students Found !</h6>
              <p className="text-secondary small mb-0">It seems like no students have joined the community yet.</p>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default TeamLeaderboard